import { Button, FormControl, FormControlLabel, Grid, Link, Radio, Typography } from '@mui/material';
import { RadioGroupStyled } from '../../../../../shared/ui/form/radioGroupStyled/RadioGroupStyled.styled';
import { Input } from '../../../../../shared/ui/form/input/Input';
import { FileUploadLayout } from '../../../../../shared/fileUploadLayer/FileUploadLayer';
import { ModalRoot } from '../../../../../shared/modal/ModalRoot';
import React from 'react';
import { usePublicationsModal } from './usePublicationsModal.vm';
import { LabelRadioGroup } from '../../../../user/caseDraft/CaseDraft.styled';
import { titleType } from '../../../libraryData';
import { IModalType } from '../../../../../../interfaces/library/library';
import { Cap } from '../../../Library.styled';
import { themeMUI } from '../../../../../../theme/theme';


interface IProps {
  open: boolean,
  handleClose: () => void
  typeModal: string | null
  id: number | null
}

export const PublicationsModal: React.FC<IProps> = ({ typeModal, id, open, handleClose }) => {
  const {
    checkboxes,
    formik,
    handleOnClick,
    setFileHandler,
    pdfFile,
    pdfLink,
    pdfFileError,
    handleDeleteItem,
    titleErrorMessage
  } = usePublicationsModal(handleClose, id);

  return (
    <ModalRoot open={open} handleClose={handleClose} title={titleType[typeModal as keyof IModalType]}>
      <Grid container pt={2} pb={2} pl={3} pr={3} flexDirection={'column'}>
        {typeModal !== 'delete' && <>
          <Grid item xs={12}>
            <FormControl>
              <RadioGroupStyled
                row
                name='publications'>
                <LabelRadioGroup error={Boolean(formik.touched.publications) && Boolean(formik.errors.publications)}>*Wybierz
                  podkategorię
                  leku:</LabelRadioGroup>
                {checkboxes.map(el => (
                  <FormControlLabel
                    checked={el.id === +formik.values.publications}
                    onChange={formik.handleChange}
                    value={el.id}
                    key={el.id}
                    control={<Radio
                      color={formik.touched.publications && Boolean(formik.errors.publications) ? 'error' : 'primary'} />}
                    label={el.title} />
                ))}
              </RadioGroupStyled>
            </FormControl>
          </Grid>
          <Grid item xs={12} pt={1} pb={1} display={'flex'} gap={'16px'}>
            <Grid item xs={8}>
              <Input fullWidth={true} name={'author'} label={'*Imię/nazwisko autora wiodącego publikacji'}
                     type={'text'}
                     onChange={formik.handleChange} value={formik.values.author}
                     error={formik.touched.author && Boolean(formik.errors.author)} />
            </Grid>
            <Grid item xs={4}>
              <Input placeholder={'YYYY.MM'} fullWidth={true} name={'datePublication'}
                     label={'*Data oryginalnej publikacji'}
                     type={'text'}
                     onChange={formik.handleChange} value={formik.values.datePublication}
                     error={formik.touched.datePublication && Boolean(formik.errors.datePublication)} />
            </Grid>
          </Grid>
          <Grid item xs={12} pt={1} pb={1}>
            <Input fullWidth={true} name={'publisher'} label={'*Nazwa wydawcy'} type={'text'}
                   onChange={formik.handleChange} value={formik.values.publisher}
                   error={formik.touched.publisher && Boolean(formik.errors.publisher)} />
          </Grid>
          <Grid item xs={12} pt={1} pb={1}>
            <Input rows={2} multiline fullWidth={true} name={'title'} label={'*Tytuł publikacji'} type={'text'}
                   onChange={formik.handleChange} value={formik.values.title}
                   error={formik.touched.title && Boolean(formik.errors.title)} />
          </Grid>
          {titleErrorMessage && <Grid item xs={12}>
            <Typography variant={'caption'}
                        style={{ color: themeMUI.palette.error.main }}>{titleErrorMessage}</Typography>
          </Grid>}
          <Grid item xs={12} alignSelf='stretch' height='152px' pt={1} sx={{ position: 'relative' }}>
            <><FileUploadLayout
              htmlFor={'publications'}
              setFileHandler={setFileHandler}
              maxFileSize={8}
              extensions={['pdf']}
              fileType={'pdf'}
            />
              {pdfFileError && <p style={{ color: 'red', fontSize: '12px' }}>Wybierz plik</p>}</>
            {typeModal === 'edit' && <Cap />}
          </Grid>
          <Grid item xs={12} mb={1} pt={2} sx={{ wordBreak: 'break-all' }}>
            {pdfLink &&
              <Link href={pdfLink ?? undefined} target={'_blank'} rel='noreferrer'>{pdfFile?.name || pdfLink}</Link>}
          </Grid>
        </>}
        {typeModal === 'delete' &&
          <Typography variant={'body1'}>Czy jesteś pewien/pewna że chcesz usunąć plik?</Typography>}
        <Grid container width={'693px'} justifyContent={'flex-end'} mt={2}>
          <Grid item>
            <Button disabled={false} variant='outlined' color={'primary'}
                    onClick={handleClose}>Anuluj</Button>
          </Grid>
          <Grid item ml={2}>
            <Button disabled={false} variant='contained' color={'primary'}
                    onClick={typeModal === 'delete' ? handleDeleteItem : handleOnClick}>{typeModal === 'delete' ? 'Usuń' : 'Zapisz'}</Button>
          </Grid>
        </Grid>
      </Grid>
    </ModalRoot>
  );
};